import React from 'react';
import styled from 'styled-components';

import {colors} from "@/constants/theme";

import {CheckboxProps} from './types';
import {ReactComponent as CheckboxIcon} from './checkbox.svg';
import {ReactComponent as CheckboxCheckedIcon} from './checkbox-checked.svg';

export const Checkbox: React.FC<CheckboxProps> = ({
                                                    id,
                                                    checked,
                                                    onChange,
                                                    label
                                                  }) => {
  return (
    <Component>
      {checked ? <CheckboxCheckedIcon/> : <CheckboxIcon/>}
      <Input
        id={id}
        checked={checked}
        type="checkbox"
        onChange={(event) => onChange?.(event.target.checked)}
      />
      {label ? <Label dangerouslySetInnerHTML={{__html: label}}/> : null}
    </Component>
  );
};

const Component = styled.label`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: 1;
`;

const Label = styled.span`
  margin-left: 10px;
  font-size: 12px;
  line-height: 16px;
  position: relative;
  z-index: 2;
  a{
    color: ${colors.primary};
    text-decoration: underline;
    &:hover{
      text-decoration: none;
    }
  } 
  `;
